import React from 'react';
import { View } from 'react-native';

import { Text } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { createCorrectMarketRestockStyles } from './CorrectMarketRestockView.styles';

const RestockCorrectionStat = ({ label, value, hint }) => {
	const styles = useThemedStyles(createCorrectMarketRestockStyles);

	return (
		<View style={styles.stat}>
			<Text style={styles.fieldLabel}>{label}</Text>
			<Text style={styles.statValue}>{value}</Text>
			{Boolean(hint) && <Text style={styles.hint}>{hint}</Text>}
		</View>
	);
};

export default RestockCorrectionStat;
